import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import LandingPage from './pages/Landing';
import LoginPage from './pages/Login';
import FundListPage from './pages/portal/FundList';
import FundDetailPage from './pages/portal/FundDetail';
import InterestPage from './pages/portal/Interest';
import RestructuringPage from './pages/portal/Restructuring';
import AdminUsersPage from './pages/admin/Users';
import AdminInterestPage from './pages/admin/InterestInbox';
import AdminContentPage from './pages/admin/ContentStatus';
import AdminLegalBridgePage from './pages/admin/LegalBridge';
import AdminCrmPage from './pages/admin/Crm';
import AdminContactDetailPage from './pages/admin/ContactDetail';
import { useAuth } from './hooks/useAuth';

function Protected({
  children,
  role,
  entitlement,
}: {
  children: React.ReactNode;
  role?: 'admin' | 'investor';
  entitlement?: string;
}) {
  const { user, loading, hasEntitlement, isAdmin } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center text-ink-700">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (role === 'admin' && !isAdmin) {
    return <Navigate to="/portal" replace />;
  }
  if (entitlement && !hasEntitlement(entitlement)) {
    return <Navigate to="/portal" replace />;
  }
  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/portal"
        element={
          <Protected>
            <FundListPage />
          </Protected>
        }
      />
      <Route
        path="/portal/funds/:slug"
        element={
          <Protected>
            <FundDetailPage />
          </Protected>
        }
      />
      <Route
        path="/portal/interest"
        element={
          <Protected>
            <InterestPage />
          </Protected>
        }
      />
      <Route
        path="/portal/restructuring"
        element={
          <Protected entitlement="restructuring">
            <RestructuringPage />
          </Protected>
        }
      />
      <Route
        path="/admin/crm"
        element={
          <Protected role="admin">
            <AdminCrmPage />
          </Protected>
        }
      />
      <Route
        path="/admin/crm/:id"
        element={
          <Protected role="admin">
            <AdminContactDetailPage />
          </Protected>
        }
      />
      <Route
        path="/admin/users"
        element={
          <Protected role="admin">
            <AdminUsersPage />
          </Protected>
        }
      />
      <Route
        path="/admin/interest"
        element={
          <Protected role="admin">
            <AdminInterestPage />
          </Protected>
        }
      />
      <Route
        path="/admin/content"
        element={
          <Protected role="admin">
            <AdminContentPage />
          </Protected>
        }
      />
      <Route
        path="/admin/legal-bridge"
        element={
          <Protected role="admin">
            <AdminLegalBridgePage />
          </Protected>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
